export default __webpack_public_path__ + "static/media/vi_1.42b71df8.gif";